// ABOUTME: The link table's editing state the `link` additional info cells read: linked rows and the extraInfo entries.
// ABOUTME: Kept in a context so the column definitions stay stable and an edit does not remount every cell of the row.

import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export type LinkInfoState = {
    /** the rows the link field links to: only those carry additional info */
    linkedIds: ReadonlySet<string>;
    extraInfo: Record<string, string>[] | undefined;
    setExtraInfo: Dispatch<SetStateAction<Record<string, string>[] | undefined>> | undefined;
    disabled: boolean;
};

const LinkInfoStateContext = createContext<LinkInfoState>({
    linkedIds: new Set(),
    extraInfo: undefined,
    setExtraInfo: undefined,
    disabled: true,
});

export const LinkInfoStateProvider = LinkInfoStateContext.Provider;

export const useLinkInfoState = (): LinkInfoState => useContext(LinkInfoStateContext);
